import { SubscriptionStatus, SubscriptionType } from "./enum/subscriptionType";

export interface SubscriptionDto {
  referenceSubscriptionId: string;
  type: string;
  status: string;
}

export class Subscription {
  subscriptionId: string;
  type: SubscriptionType;
  status: SubscriptionStatus;

  constructor(dto: SubscriptionDto) {
    this.subscriptionId = dto.referenceSubscriptionId;
    this.type = SubscriptionType[dto.type as keyof typeof SubscriptionType];
    this.status =
      SubscriptionStatus[dto.status as keyof typeof SubscriptionStatus];
  }

  isValid(): boolean {
    return this.status === SubscriptionStatus.ACTIVE;
  }
}
